// === Данные курсов для динамического управления ===
export const courses = [
  {
    id: 1,
    title: 'SOS-помощь при панических атаках/страхах',
    description: 'Экстренные техники для быстрого снятия панических атак и управления страхами',
    duration: '3 недели',
    level: 'Начальный',
    price: '€199',
    originalPrice: '€299',
    students: 1247,
    rating: 4.9,
    image: '/images/courses/panic-attacks.jpg',
    featured: true, // Рекомендуемый курс
    category: 'Экстренная помощь',
    instructor: 'Альфира Херрманн',
    language: 'Русский',
    startDate: '2024-02-01',
    enrollmentDeadline: '2024-01-25',
    maxStudents: 50,
    status: 'active', // active, coming_soon, archived
    features: [
      '6 видеоуроков',
      'Аудио-медитации для экстренных случаев',
      'Техники дыхания',
      'Поддержка в чате 24/7',
      'Сертификат о прохождении'
    ],
    modules: [
      {
        id: 1,
        title: 'Понимание панических атак',
        duration: '45 мин',
        lessons: 2,
        icon: 'Brain',
        description: 'Что такое панические атаки и как они возникают'
      },
      {
        id: 2,
        title: 'Экстренные техники',
        duration: '60 мин',
        lessons: 3,
        icon: 'Heart',
        description: 'Методы быстрого снятия приступа'
      },
      {
        id: 3,
        title: 'Долгосрочная работа',
        duration: '50 мин',
        lessons: 2,
        icon: 'Target',
        description: 'Предотвращение повторных атак'
      },
      {
        id: 4,
        title: 'Интеграция в жизнь',
        duration: '40 мин',
        lessons: 1,
        icon: 'CheckCircle',
        description: 'Применение навыков в повседневности'
      }
    ],
    requirements: [
      'Готовность к работе с тревожностью',
      'Регулярная практика',
      'Поддержка близких'
    ],
    learningOutcomes: [
      'Умение быстро снимать панические атаки',
      'Снижение общего уровня тревожности',
      'Повышение уверенности',
      'Улучшение качества жизни'
    ]
  },
  {
    id: 2,
    title: 'Самооценка',
    description: 'Работа с самооценкой и уверенностью в себе через гипнотерапию',
    duration: '5 недель',
    level: 'Средний',
    price: '€299',
    originalPrice: '€399',
    students: 892,
    rating: 4.8,
    image: '/images/courses/self-esteem.jpg',
    featured: false,
    category: 'Личностный рост',
    instructor: 'Альфира Херрманн',
    language: 'Русский',
    startDate: '2024-02-15',
    enrollmentDeadline: '2024-02-10',
    maxStudents: 30,
    status: 'active',
    features: [
      '10 видеоуроков',
      'Гипнотические сессии',
      'Дневник самооценки',
      'Групповые сессии',
      'Персональная консультация'
    ],
    modules: [
      {
        id: 1,
        title: 'Анализ самооценки',
        duration: '55 мин',
        lessons: 3,
        icon: 'Brain',
        description: 'Диагностика текущего уровня самооценки'
      },
      {
        id: 2,
        title: 'Работа с убеждениями',
        duration: '70 мин',
        lessons: 4,
        icon: 'Heart',
        description: 'Изменение негативных установок'
      },
      {
        id: 3,
        title: 'Техники уверенности',
        duration: '60 мин',
        lessons: 3,
        icon: 'Target',
        description: 'Развитие уверенности в себе'
      },
      {
        id: 4,
        title: 'Закрепление результата',
        duration: '50 мин',
        lessons: 2,
        icon: 'CheckCircle',
        description: 'Поддержание достигнутых результатов'
      }
    ],
    requirements: [
      'Готовность к глубокой работе',
      'Регулярные практики',
      'Открытость к изменениям'
    ],
    learningOutcomes: [
      'Повышение самооценки',
      'Уверенность в себе',
      'Позитивное мышление',
      'Улучшение отношений с окружающими'
    ]
  },
  {
    id: 3,
    title: 'Снижение веса',
    description: 'Гипнотерапевтические техники для здорового снижения веса',
    duration: '8 недель',
    level: 'Средний',
    price: '€399',
    originalPrice: '€599',
    students: 456,
    rating: 4.9,
    image: '/images/courses/weight-loss.jpg',
    featured: true,
    category: 'Здоровье',
    instructor: 'Альфира Херрманн',
    language: 'Русский',
    startDate: '2024-03-01',
    enrollmentDeadline: '2024-02-25',
    maxStudents: 20,
    status: 'active',
    features: [
      '16 видеоуроков',
      'Индивидуальные сессии',
      'План питания',
      'Поддержка диетолога',
      'Гарантия результата'
    ],
    modules: [
      {
        id: 1,
        title: 'Анализ пищевого поведения',
        duration: '60 мин',
        lessons: 4,
        icon: 'Brain',
        description: 'Понимание причин переедания'
      },
      {
        id: 2,
        title: 'Работа с эмоциональным питанием',
        duration: '70 мин',
        lessons: 5,
        icon: 'Heart',
        description: 'Управление стрессом без еды'
      },
      {
        id: 3,
        title: 'Гипнотические техники',
        duration: '80 мин',
        lessons: 6,
        icon: 'Target',
        description: 'Изменение отношения к еде'
      },
      {
        id: 4,
        title: 'Поддержание результата',
        duration: '45 мин',
        lessons: 3,
        icon: 'CheckCircle',
        description: 'Долгосрочное сохранение веса'
      }
    ],
    requirements: [
      'Готовность к изменению пищевых привычек',
      'Регулярные практики',
      'Консультация с врачом'
    ],
    learningOutcomes: [
      'Здоровое снижение веса',
      'Изменение пищевых привычек',
      'Повышение мотивации',
      'Улучшение самочувствия'
    ]
  },
  {
    id: 4,
    title: 'Психосоматика',
    description: 'Работа с психосоматическими расстройствами через гипнотерапию',
    duration: '6 недель',
    level: 'Продвинутый',
    price: '€349',
    originalPrice: '€499',
    students: 234,
    rating: 4.7,
    image: '/images/courses/psychosomatics.jpg',
    featured: false,
    category: 'Здоровье',
    instructor: 'Альфира Херрманн',
    language: 'Русский',
    startDate: '2024-03-15',
    enrollmentDeadline: '2024-03-10',
    maxStudents: 15,
    status: 'active',
    features: [
      '12 видеоуроков',
      'Индивидуальные сессии',
      'Работа с симптомами',
      'Поддержка врача',
      'Гарантия результата'
    ],
    modules: [
      {
        id: 1,
        title: 'Понимание психосоматики',
        duration: '60 мин',
        lessons: 3,
        icon: 'Brain',
        description: 'Связь психики и тела'
      },
      {
        id: 2,
        title: 'Диагностика причин',
        duration: '70 мин',
        lessons: 4,
        icon: 'Heart',
        description: 'Выявление психологических причин'
      },
      {
        id: 3,
        title: 'Гипнотерапевтические техники',
        duration: '80 мин',
        lessons: 5,
        icon: 'Target',
        description: 'Работа с симптомами'
      },
      {
        id: 4,
        title: 'Интеграция и профилактика',
        duration: '50 мин',
        lessons: 3,
        icon: 'CheckCircle',
        description: 'Предотвращение рецидивов'
      }
    ],
    requirements: [
      'Консультация с врачом',
      'Готовность к глубокой работе',
      'Регулярные практики'
    ],
    learningOutcomes: [
      'Снижение психосоматических симптомов',
      'Улучшение общего самочувствия',
      'Понимание связи психики и тела',
      'Навыки самопомощи'
    ]
  }
];

// Категории курсов
export const courseCategories = [
  { id: 'emergency-help', name: 'Экстренная помощь', description: 'Быстрые техники для критических ситуаций' },
  { id: 'personal-growth', name: 'Личностный рост', description: 'Развитие уверенности и самооценки' },
  { id: 'health', name: 'Здоровье', description: 'Работа с физическими и психосоматическими проблемами' },
  { id: 'weight-management', name: 'Управление весом', description: 'Здоровое снижение веса через гипнотерапию' }
];

// Уровни сложности
export const courseLevels = [
  { id: 'beginner', name: 'Начальный', description: 'Для новичков' },
  { id: 'intermediate', name: 'Средний', description: 'Для имеющих базовые знания' },
  { id: 'advanced', name: 'Продвинутый', description: 'Для опытных практиков' }
];

// Функции для работы с курсами
export const courseUtils = {
  // Получить все активные курсы
  getActiveCourses: () => courses.filter(course => course.status === 'active'),
  
  // Получить рекомендуемые курсы
  getFeaturedCourses: () => courses.filter(course => course.featured === true),
  
  // Получить курсы по категории
  getCoursesByCategory: (category) => courses.filter(course => course.category === category),
  
  // Получить курсы по уровню
  getCoursesByLevel: (level) => courses.filter(course => course.level === level),
  
  // Найти курс по ID
  getCourseById: (id) => courses.find(course => course.id === id),
  
  // Получить курсы с доступной записью
  getAvailableCourses: () => {
    const now = new Date();
    return courses.filter(course => 
      course.status === 'active' && 
      new Date(course.enrollmentDeadline) > now
    );
  }
};

// Отзывы студентов
export const courseTestimonials = [
  {
    id: 1,
    courseId: 1,
    name: 'Анна К.',
    course: 'SOS-помощь при панических атаках/страхах',
    text: 'Курс спас меня! Теперь я знаю, как быстро справиться с панической атакой. Техники действительно работают.',
    rating: 5,
    date: '2024-01-15',
    verified: true
  },
  {
    id: 2,
    courseId: 2,
    name: 'Михаил С.',
    course: 'Самооценка',
    text: 'Отличный курс! Моя самооценка значительно выросла. Теперь я чувствую себя увереннее в любой ситуации.',
    rating: 5,
    date: '2024-01-10',
    verified: true
  },
  {
    id: 3,
    courseId: 3,
    name: 'Елена В.',
    course: 'Снижение веса',
    text: 'Благодаря этому курсу я сбросила 15 кг и изменила свое отношение к еде. Рекомендую всем!',
    rating: 5,
    date: '2024-01-05',
    verified: true
  },
  {
    id: 4,
    courseId: 4,
    name: 'Дмитрий П.',
    course: 'Психосоматика',
    text: 'Курс помог мне понять связь между моими эмоциями и физическими симптомами. Головные боли прошли!',
    rating: 4,
    date: '2024-01-20',
    verified: true
  }
];

// Преимущества обучения
export const learningBenefits = [
  {
    icon: 'Video',
    title: 'Видеоуроки',
    description: 'Высококачественные видео с подробными объяснениями'
  },
  {
    icon: 'FileText',
    title: 'Материалы',
    description: 'Практические пособия и рабочие тетради'
  },
  {
    icon: 'Users',
    title: 'Поддержка',
    description: 'Доступ к сообществу и помощь преподавателя'
  },
  {
    icon: 'Award',
    title: 'Сертификат',
    description: 'Официальный сертификат о прохождении курса'
  }
];
